
<template>
  <div class="container-fluid loginPages p-0">
    <div class="container py-4">
        <div class="row d-block m-0">
            <img src="static/images/logo.png" class="img-fluid">
            <router-link class="saas-btn mt-0 float-right" to="/login">{{$ml.get('LOGIN')}}</router-link>
          </div>
    </div>
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <div class="container mt-3 mb-5">
        <div class="row loginInfo" v-if="sendMail">
            <div class="col-12 col-md-6 text-center">
            <img src="@/assets/passwordchange.png" class="img-fluid">
            </div>
            <div class="col-6 align-items-center d-flex">
                <div>
                    <h2 class="title">{{$ml.get('SEND_SUCCESSFULLY')}}</h2>
                    <div class="text font-m">{{$ml.get('PASSWORD_SEND_YOUR_MAIL')}}</div>
                    <router-link class="saas-btn mt-4 saas-btn" to="/login">{{$ml.get('LOGIN')}}</router-link>
                </div>
            </div>
        </div>
        <div class="row loginInfo" v-else>
            <div class="col-6 text-center">
            <img src="@/assets/sifremi-unuttum.png" class="img-fluid">
            </div>
            <div class="col-12 col-md-6">

            <h2 class="title">{{$ml.get('FARGOT_MY_PASSWORD')}}</h2>
            <div class="text font-m">{{$ml.get('ENTER_MAIL_REGISTERED')}}</div>
            <div class="mt-3">
                <form class="login-form saas-form" v-on:submit.prevent="resetUserPassword">
                <label for="email" class="saas-label">{{$ml.get('E_MAIL')}}</label>
                <div class="saas-form-control" :class="{isDanger:emailError.state==true}">
                    <input type="text" @input="emailValidation" class="saas-input" v-model="email">
                    <div class="col-12 d-block px-0 input-error">
                    <span class="alert-input" v-if="emailError.state">{{emailError.message}}</span>
                    </div>
                </div>
                <input type="submit" class="saas-btn mt-3" :value="$ml.get('SEND')">
                <router-link class="saas-btn saas-btn-transparent saas-btn ml-3 mt-3" to="/login">{{$ml.get('CANCEL')}}</router-link>
                
                </form>
            </div>
            </div>
        </div>
    </div>
    <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />

    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import {mapActions} from 'vuex'
import Footer from './footer.vue'

import swal from 'sweetalert'
export default {
    name: 'ForgotPassword',
    data () {
        return {
            email:'',
            sendMail:false,
            emailError:{state:false,message:''},
        }
    },
    computed: {
      ...mapState([
          'baseUrl'
      ])
    },
    components:{
      Footer
    },
    methods:{
        isLogin(){
          axios({
            method:'GET',
            url:'/authenticate',
            baseURL: this.baseUrl,
            withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
            if(res.data.status){
                this.$router.push('/deals')
            }else{
                this.$router.push('/login')
            }
          })
        },
        validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        emailValidation(){
            this.emailError.state = false
            this.emailError.message=''
            if(this.email==''){
                this.emailError.message=this.$ml.get('PLEASE_ENTER_YOUR_MAIL')
                this.emailError.state = true
                return false
            }
            else if(!this.validateEmail(this.email)){
                this.emailError.message=this.$ml.get('PLEASE_ENTER_VALID_MAIL')
                this.emailError.state = true
                return false
            }
            this.emailError.state = false
            return true
            
        },
        resetUserPassword(){
          this.emailValidation()
          if(
              !this.emailValidation()
          ){
              return false
          }
           
            axios({
              method:'POST',
              url:'/resetUserPassword',
              baseURL: this.baseUrl,
              data: {
                email:this.email
              },
              withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
              if(res.data.status.code==0){                
                  
                this.sendMail=true
              }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
                this.$router.push('/login')
                
              }
            })
        },
        ...mapActions([
            'updateLoading',
        ]),
        created(){
            this.isLogin()
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,900");
body{
    background-color: #E5E5E5 !important;
    color: #677294;
  }
.form-check{
  padding-top: 0.5rem;
  padding-left: 0rem;
}
.form-check label{
  cursor: pointer;
}
h1{
  color: white;
}
.form-check{
  font-size: 0.9rem;
}

</style>
